import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export const getAll = async (filters: any) => {
  let queryParams: string[] = [];

  if (filters) {
    if (filters.init_date) {
      queryParams.push(`init_date=${filters.init_date}`);
    }
    if (filters.end_date) {
      queryParams.push(`end_date=${filters.end_date}`);
    }
    if (filters.search) {
      queryParams.push(`search=${encodeURIComponent(filters.search)}`);
    }
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  const response = await axios.get(`${API_URL}catalogos/recharge${queryString}`);
  return response.data.doc.data;
};
export const createRecharge = async (values: any) => {
  const { phoneFormat, offer_id, product_type = 'telefonia' } = values;
    const response = await axios.post(`${API_URL}operation/recharge/`, {
      numero_telefono: phoneFormat,
      offer_id: Number(offer_id),
      product_type: product_type,
    });
    return response;
}